module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg5MS43IDE0My44YTMyIDMyIDAgMCAxIDQgMjEuM2wtMTA4LjUgNjYwLjhhMzIgMzIgMCAwIDEtNDMuNCAyNC41bC0yMDAuMy03OS44LTgyLjkgMTEyLjNBMzIgMzIgMCAwIDEgNDAyLjkgODY0di0xMjguNGE2NCA2NCAwIDAgMSAxNC40LTQwLjRsMjgwLjMtMzQ0YTkuNiA5LjYgMCAwIDAtMTMuOC0xMy4zTDMzNy45IDY0MS42YTY0IDY0IDAgMCAxLTY2LjUgMTEuMWwtMTIzLjYtNTAuN2EzMiAzMiAwIDAgMS00LTU3LjJMODQ4IDEzMi40YTMyIDMyIDAgMCAxIDQzLjggMTEuNXoiIGZpbGw9IiMwIiBwLWlkPSIzNjIzIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Send-filled.svg
// module id = nRFn
// module chunks = 73